import * as React from 'react';
export const recurringInvoiceSvg = React.forwardRef(
  function recurringInvoiceSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M11.75 1.5c.966 0 1.75.784 1.75 1.75V12a.75.75 0 0 0 1.5 0V3.25A3.25 3.25 0 0 0 11.75 0H5a.75.75 0 0 0 0 1.5h6.75Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm2.5 13.81.38-.326a1.75 1.75 0 0 1 2.11-.127l1.51 1.007 1.51-1.007a1.75 1.75 0 0 1 2.11.127l.38.326V5a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.25a.75.75 0 0 1-1.5 0V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v9.796a1 1 0 0 1-.265.679l-.301.326a.62.62 0 0 1-.858.05l-1.432-1.228a.25.25 0 0 0-.302-.018l-1.884 1.256a.826.826 0 0 1-.916 0l-1.884-1.256a.25.25 0 0 0-.302.018l-1.432 1.228a.62.62 0 0 1-.858-.05l-.3-.326A1 1 0 0 1 1 14.797V10.75A2.75 2.75 0 0 1 3.75 8h2.58l-.89-1.002a.75.75 0 0 1 1.12-.996l2 2.25a.75.75 0 0 1 .026.967l-2 2.5a.75.75 0 1 1-1.172-.938L6.44 9.5H3.75c-.69 0-1.25.56-1.25 1.25v3.06Z',
      }),
    );
  },
);
recurringInvoiceSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var recurringInvoice = {
  category: 'icon',
  colorable: true,
  name: 'recurringInvoice',
  svg: recurringInvoiceSvg,
};
